/**
 * DerivacionBanner — señal de alarma detectada en la consulta (2026-09-30).
 * Va arriba de la respuesta: la derivación manda sobre cualquier producto.
 * Rojo = emergencias ya; ámbar = médico hoy; azul = consulta médica pronto.
 */
import type { Derivacion } from '../types/sse'

const ESTILO: Record<Derivacion['urgencia'], { bg: string; border: string; ink: string }> = {
  urgencias: { bg: '#fee2e2', border: '#dc2626', ink: '#991b1b' },
  medico_hoy: { bg: '#fef3c7', border: '#f59e0b', ink: '#92400e' },
  medico_pronto: { bg: '#e0f2fe', border: '#0284c7', ink: '#075985' },
}

export function DerivacionBanner({ derivacion }: { derivacion: Derivacion[] }) {
  if (derivacion.length === 0) return null
  const [principal, ...otras] = derivacion
  const e = ESTILO[principal.urgencia] ?? ESTILO.medico_hoy
  return (
    <div
      role="alert"
      className="rounded-xl px-4 py-3 grid gap-1"
      style={{ background: e.bg, border: `2px solid ${e.border}`, color: e.ink }}
    >
      <div className="text-[15px] font-bold uppercase tracking-wide">{principal.titulo}</div>
      <div className="text-[14px] leading-snug">{principal.mensaje}</div>
      {otras.length > 0 && (
        <div className="text-[13px] leading-snug">
          También: {otras.map((o) => o.situacion ?? o.titulo).join('; ')}.
        </div>
      )}
      <a
        href={principal.source_url}
        target="_blank"
        rel="noreferrer"
        className="text-[13px] underline opacity-80"
      >
        Fuente: {principal.fuente}
      </a>
    </div>
  )
}
